import { FC } from 'react';
import SwiperCommon from '../../components/SwiperCommon';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.teaser.FreedomB');

    const listA = {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717760884357/ab1%20(1).jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717658191780/Frame%201000008332%20(1).png',
        subtitle: t('item1_l'),
        desc: t('item1_r'),
    };
    // const isMobile = getIsPadWidth();
    // if (isMobile) {
    //     listA.pc = H5_IMG;
    // }
    return (
        <div className={`dp3-module-box dp3-teaser-FreedomB ${styles.theComp}`}>
            <div className="comp-module">
                <div className="dp3-title">{t('title')}</div>
                <SwiperCommon list={[listA]} />
            </div>
        </div>
    );
};

export default TheComp;
